import React from 'react'
import { useNotification } from '~/hooks/server/notification'
import NotificationBar from '~/components/atoms/bar/NotificationBar'

const AppNotificationBar = () => {
  const notification = useNotification()
  return (
    <>
      {notification && notification.message &&
        <NotificationBar text={notification.message} link={notification.link}/>
      }
    </>
  )
}

export default AppNotificationBar
